import { render, staticRenderFns } from "./help07.vue?vue&type=template&id=22d6261e&"
import script from "./help07.vue?vue&type=script&lang=js&"
export * from "./help07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports